import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import ProdutoIcon from "../../assets/icons/produtos.png";
import ProdutosService from "../../services/ProdutosService";

export default function ProdutosForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idProduto: null,
    referencia: "",
    descricao: "",
    valor: "",
    custo: "",
    validade: "",
    ativo: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idProduto: null,
        referencia: "",
        descricao: "",
        valor: "",
        custo: "",
        validade: "",
        ativo: true,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idProduto: itemSelecionado.IDPRODUTO,
        referencia: itemSelecionado.REFERENCIA,
        descricao: itemSelecionado.DESCRICAO,
        valor: itemSelecionado.VALOR,
        custo: itemSelecionado.CUSTO ?? "",
        validade: itemSelecionado.VALIDADE ?? "",
        ativo: itemSelecionado.ATIVO,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.referencia) e.referencia = "Informe a referência";
    if (!form.descricao) e.descricao = "Informe a descrição";
    if (!form.valor) e.valor = "Informe o valor";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {
        const payload_create = { 
          REFERENCIA: form.referencia,
          DESCRICAO: form.descricao,
          VALOR: form.valor.replace(",", "."),
          CUSTO: form.custo.replace(",", "."),
          VALIDADE: form.validade,
          ATIVO: form.ativo
         };

        await ProdutosService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Produto criado com sucesso!",
        });

        setSubmitState("SUCCESS");
      }

      if (modo === "alterar") {
        const payload_update = { 
          IDPRODUTO: form.idProduto,
          REFERENCIA: form.referencia,
          DESCRICAO: form.descricao,
          VALOR: form.valor.replace(",", "."),
          CUSTO: form.custo.replace(",", "."),
          VALIDADE: form.validade,
          ATIVO: form.ativo
        };
        await ProdutosService.update(
          form.idProduto,
          payload_update
        );

        setRetorno({
          tipo: "sucesso",
          mensagem: "Produto atualizado com sucesso!",
        });

        setSubmitState("SUCCESS");
      }

      onClose();
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar produto."
            : "Erro ao atualizar produto.",
      });

      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={ProdutoIcon} alt="" className="icon" />
          {modo === "novo"
            ? "Cadastro de Produto"
            : "Alterar Produto"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Código: *</div>
          <input
            name="referencia"
            value={form.referencia}
            onChange={handleChange}
          />
          {errors.referencia && (
            <span style={{ color: "red" }}>{errors.referencia}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição: *</div>
          <input
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
          />
          {errors.descricao && (
            <span style={{ color: "red" }}>{errors.descricao}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Valor: *</div>
          <input
            name="valor"
            placeholder="0,00"
            value={form.valor}
            onChange={handleChange}
          />
          {errors.valor && (
            <span style={{ color: "red" }}>{errors.valor}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Custo</div>
          <input
            name="custo"
            placeholder="0,00"
            value={form.custo}
            onChange={handleChange}
          />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Validade</div>
          <input
            type="date"
            name="validade"
            value={form.validade}
            onChange={handleChange}
          />
        </div>

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select
              name="ativo"
              value={String(form.ativo)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
